export default "__VITE_ASSET__Yd3YmMft__"